import {
  combineLatest,
  distinctUntilChanged,
  map,
  type Observable,
} from 'rxjs';
import { Features, featureOperations } from '@ardoq/features';
import { featureContext$ } from 'streams/featureContext$';
import { isDiscoverJourney$ } from './isDiscoverJourney';

export const isQuickExploreSelectionEnabled$: Observable<boolean> =
  combineLatest([isDiscoverJourney$, featureContext$]).pipe(
    map(
      ([isDiscoverJourney, featureContext]) =>
        isDiscoverJourney ||
        featureOperations.hasFeature(featureContext, Features.CANVAS_PROTOTYPE)
    ),
    distinctUntilChanged()
  );
